'use client';

import { IconErrorFilled } from '@zillow/constellation-icons/react/filled/icon-error-filled';
import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { FormFieldContext } from '../form-field/context/form-field.context';
import { Icon } from '../icon/icon';
import { formHelpRecipe } from './styles/form-help.styles';
import type { FormHelpPropsInterface } from './types/form-help.types';

/**
 * @related ['FieldSet', 'FormField']
 * @since 4.0.0
 */

export const FormHelp = forwardRef<HTMLParagraphElement, FormHelpPropsInterface>(
  (props: FormHelpPropsInterface, forwardedRef) => {
    const formFieldContext = useContext(FormFieldContext);
    const {
      children,
      className,
      css: cssProp,
      disabled = formFieldContext.disabled || false,
      error = formFieldContext.error || false,
      ...rest
    } = props;
    const styles = css(formHelpRecipe.raw({ disabled, error }), cssProp);
    return (
      <p
        aria-disabled={disabled || undefined}
        className={cx('c11n', 'c11n_form-help', 'c11n-semantic', styles, className)}
        id={formFieldContext.descriptionId}
        data-c11n-component="FormHelp"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      >
        {error ? <Icon size="sm" render={<IconErrorFilled />} /> : null}
        {children}
      </p>
    );
  },
);

FormHelp.displayName = 'FormHelp';
